import axios from "axios";

export const CreateSubscription = async (planId, userId, customerID) => {

    const url = `${process.env.REACT_APP_BASE_URL}create-subscription`;

    let expireBy;
    let totalCount;
    let planName = null;

    // Define your plan logic here
    if (
        planId === process.env.REACT_APP_STARTER_PLANID_INR ||
        planId === process.env.REACT_APP_STARTER_PLANID_USD
    ) {
        totalCount = 1;

        const currentDate = new Date();
        const expiryDate = new Date(currentDate);

        // ✅ 1 YEAR expiry
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);

        expireBy = expiryDate.getTime();
        planName = "Starter Plan";

    } else if (
        planId === process.env.REACT_APP_PROFESSIONAL_PLANID_INR ||
        planId === process.env.REACT_APP_PROFESSIONAL_PLANID_USD
    ) {
        totalCount = 1;

        const currentDate = new Date();
        const expiryDate = new Date(currentDate);

        // ✅ 1 YEAR expiry
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);

        expireBy = expiryDate.getTime();
        planName = "Professional Plan";

    } else if (
        planId === process.env.REACT_APP_AGENCY_PLANID_INR ||
        planId === process.env.REACT_APP_AGENCY_PLANID_USD
    ) {
        totalCount = 1;

        const currentDate = new Date();
        const expiryDate = new Date(currentDate);

        // ✅ 1 YEAR expiry
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);

        expireBy = expiryDate.getTime();
        planName = "Agency Plan";
    }
    else {
        console.error("Unknown plan ID");
        return null;
    }

    const data = {
        plan_id: planId,
        total_count: totalCount,
        quantity: 1,
        expire_by: expireBy,
        userId: userId,
        planName: planName,
        customer_id: customerID
    };

    try {
        const response = await axios.post(url, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const { subscriptionId } = response.data;
        return subscriptionId;
    } catch (error) {
        console.error("Error creating subscription:", error);
        return null;
    }
};